import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { Partner } from '@chancenwerk/master-data-management/partner/entities/Partner.js';
import { MarktAkquiseContactRecord } from './MarktAkquiseContactRecord.js';
import { MarktAkquiseStatus } from './MarktAkquiseStatus.js';

/**
 * @entity MarktAkquise
 */
@Entity()
export class MarktAkquise extends MongoEntity {
  public static override _class = 'MarktAkquise';
  public static override _collectionName = 'markt-akquise';

  @Field(type => String)
  partnerID: Maybe<string>;

  @DataLoadedField(type => Partner, ({ partnerID }) => partnerID)
  partner: Maybe<Partner>;

  @Field(type => String)
  status: Maybe<MarktAkquiseStatus>;

  @Field(type => [MarktAkquiseContactRecord])
  contacts: Maybe<MarktAkquiseContactRecord[]>;

  getLatestStatus() {
    return this.contacts?.at(-1)?.status;
  }
}
